module.exports = __webpack_public_path__ + "img/chev-right-2.161648e6.svg";